export const formatCentsAmountToDollars = (
  cents: number,
  options: { forceCents?: boolean } = {},
): string => {
  const { forceCents } = options;
  const dollars = forceCents || cents % 100 ? (cents / 100).toFixed(2) : cents / 100;

  return `$${dollars}`;
};
